import { atomWithReset } from "jotai/utils";

import type { OrderListItemOrderItem } from "../types";

export const sendAccessModalAtom = atomWithReset<{
  visible: boolean;
  data: OrderListItemOrderItem | null;
}>({
  visible: false,
  data: null
});
